import { Component, inject, input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { CommonModule } from '@angular/common';
import { FormCheckBoxComponent } from '../form/controls/checkbox';
import { isFlagEnabled } from '../../../store/feature-flags';
import { FeatureName } from '../../../store/feature-flags/types';
import { ButtonLinkComponent } from '../ava-link/ava-link.component';

export interface TermsAndConditions {
  accept: FormControl<boolean>;
}

@Component({
  selector: 'ava-terms-and-condition',
  template: `
    <div
      [formGroup]="formGroup"
      class="tw-my-2 tw-flex tw-flex-col tw-items-start tw-gap-1 tw-rounded tw-bg-[#f3f3f3] tw-p-4"
    >
      @if (!isEmbedded) {
        <ava-form-checkbox formLabel="Yes, I have read and agree to the" formControlName="accept" />
        <span
          class="tw-cursor-pointer tw-pl-6 tw-font-extralight tw-text-[#036ecd]"
          nz-tooltip
          [nzTooltipTitle]="TermsAndConditions"
          nzTooltipTrigger="focus"
          nzTooltipPlacement="right"
          nzTooltipArrowPointAtCenter="true"
          (click)="$event.stopPropagation()"
          tabindex="0"
        >
          Terms and conditions.
        </span>
      } @else {
        <div class="tw-flex tw-flex-col tw-gap-2 tw-font-arial">
          <div>
            See
            <ava-link target="_blank" href="https://www.acg.aaa.com/terms-and-conditions-of-use.html">
              Terms and Conditions of Use
            </ava-link>
            for further details.
          </div>
          <div>
            See
            <ava-link target="_blank" href="https://www.acg.aaa.com/aaa-membership/member-handbook.html">
              Member Handbook
            </ava-link>
            for a list of member benefits, including any limitations or restrictions
          </div>
        </div>
      }
    </div>
    <ng-template #TermsAndConditions>
      <div class="tw-flex tw-flex-col tw-gap-2.5 tw-p-2.5 tw-italic">
        @for (termsAndCondition of termsAndConditions(); track termsAndCondition) {
          <div>{{ termsAndCondition }}</div>
        }
      </div>
    </ng-template>
  `,
  imports: [
    FormCheckBoxComponent,
    FormsModule,
    ReactiveFormsModule,
    NzTooltipModule,
    CommonModule,
    ButtonLinkComponent,
  ],
  standalone: true,
})
export class TermsAndConditionComponent implements OnInit {
  readonly fb = inject(FormBuilder);
  readonly isEmbedded = isFlagEnabled(FeatureName.ENABLE_TERMS_AND_CONDITIONS_EMBEDDED);

  public formGroup = this.fb.group<TermsAndConditions>({
    accept: new FormControl(false, { nonNullable: true }),
  });

  termsAndConditions = input<string[]>([]);

  ngOnInit(): void {
    if (this.isEmbedded) {
      this.acceptControl.setValue(true);
    }
  }

  public get acceptControl() {
    return this.formGroup.controls.accept;
  }
}
